import { LocalStorageAttachment, Talent } from "./talentAPI";
import { Nullable } from "../../common/types/nullable";
import { LOCAL_STORAGE_KEY } from "../talentProfile/constants";

type WithExclusivityIds = Pick<Talent, "exclusivityEntryIds">;

export const hasPoolPro = (entity: WithExclusivityIds): boolean =>
  Array.isArray(entity.exclusivityEntryIds) && entity.exclusivityEntryIds.length > 0;

export const updateTalentsList = (
  prevTalents: Talent[],
  result: Talent[],
  cursor?: Nullable<string>,
) => {
  if (!result.length) return [];

  // if cursor is not given, return the new results
  // do not append or mix them with previous data
  if (!cursor) {
    return result;
  }

  // cursor given
  const mergedTalents = [...prevTalents, ...result];

  // remove duplicates by using a map keyed by the unique talent id
  const uniqueTalents = Array.from(
    new Map(
      mergedTalents.map((talent) => [talent.id, talent]), // map each talent by its id
    ).values(), // extract the values (unique talents) from the map
  );

  return uniqueTalents;
};

export const fetchAttachments = (talentId?: string) => {
  const item = localStorage.getItem(LOCAL_STORAGE_KEY);
  const localStorageData: LocalStorageAttachment[] = !!item
    ? JSON.parse(item)
    : [];
  const attachments =
    localStorageData &&
    localStorageData.filter(
      (attachment) =>
        attachment.path === "talents" &&
        (talentId ? attachment.pathId[0] === talentId : true),
    );
  return attachments;
};
